import { render } from "./TheUpper.vue?vue&type=template&id=a631ee5a&scoped=true"
import script from "./TheUpper.vue?vue&type=script&lang=js"
export * from "./TheUpper.vue?vue&type=script&lang=js"

import "./TheUpper.vue?vue&type=style&index=0&id=a631ee5a&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a631ee5a"]])

export default __exports__